/**
 * Map of backend currency codes to display-friendly codes
 */
const currencyDisplayMap: Record<string, string> = {
  XAUT: 'GOLD',
}

/**
 * Returns the display-friendly currency code.
 * If there's no mapped override, it returns the original code.
 *
 * @param currencyCode - The original currency code from backend
 * @returns The display currency code
 */
export const getDisplayCurrencyCode = (currencyCode: string): string => {
  return currencyDisplayMap[currencyCode] || currencyCode
}
